if (!window.__obUpsell) {
  window.__obUpsell = true;
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-ob-up-add]');
    if (!button || button.disabled || window.__obUpsellBusy) return;
    e.preventDefault();
    window.__obUpsellBusy = true;
    const originalHTML = button.innerHTML;
    const qty = Math.max(1, parseInt(button.dataset.obUpQty || '1', 10) || 1);
    const status = button.closest('.obt')?.querySelector('[data-ob-up-status]');
    const showStatus = (text) => { if (status && text) { status.textContent = text; status.hidden = false; } };
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-busy');
    if (button.dataset.loading) button.textContent = button.dataset.loading;
    let deferred = null;
    let eventType = null;
    let added = false;
    try {
      const mod = await import('@shopify/events');
      eventType = mod.CartLinesUpdateEvent;
      deferred = eventType.createPromise();
      deferred.promise.catch(() => {});
      document.dispatchEvent(new eventType({action:'add',context:'cart',lines:[{merchandiseId:button.dataset.obUpAdd,quantity:qty}],promise:deferred.promise}));
    } catch {}
    try {
      const root = window.Shopify?.routes?.root || '/';
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean))].slice(0,5);
      const rawProperties = JSON.parse(button.dataset.obUpProperties || '{}');
      const properties = Array.isArray(rawProperties) ? Object.fromEntries(rawProperties) : rawProperties;
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.obUpAdd),quantity:qty,properties}],sections})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'add_failed');
      added = true;
      const cartResponse = await fetch(root + 'cart.js', {cache:'no-store',headers:{Accept:'application/json'}});
      if (!cartResponse.ok) throw new Error('cart_refresh_failed');
      const cart = await cartResponse.json();
      if (deferred && eventType) {
        deferred.resolve({cart:eventType.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'ob-cart-upsell',itemCount:qty,sections:result.sections,didError:false}});
        showStatus(button.dataset.success);
      } else {
        location.reload();
      }
    } catch (error) {
      deferred?.reject(error);
      if (added) { location.reload(); return; }
      showStatus(button.dataset.error);
    } finally {
      window.__obUpsellBusy = false;
      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-busy');
        button.innerHTML = originalHTML;
      }
    }
  });
}
